import { getDropdownRecordsByFieldname, getAllDropdown } from "../../../../Services/dropdown-services";

const dropdownRegistry = {};
const noSelectFields = ["Type", "Welded On Coupon", "Layer", "WC in Kgs/Nos"];

export const createDropdown = (fieldname) => {
  const arr = noSelectFields.includes(fieldname) ? [] : [{ name: "Select", value: "" }];
  dropdownRegistry[fieldname] = arr;
  return arr;
};

export const refreshDropdown = async (fieldname) => {
  const arr = dropdownRegistry[fieldname];
  if (!arr) return;
  const data = await getDropdownData(fieldname);
  arr.length = 0;
  arr.push(...data);
};

export const refreshAllDropdowns = async () => {
  const allData = await getAllDropdown();
  if (!Array.isArray(allData)) return;
  Object.keys(dropdownRegistry).forEach((fieldname) => {
    const arr = dropdownRegistry[fieldname];
    const filtered = allData.filter((e) => e.wld_fieldName === fieldname);
    let list;
    if (fieldname === "Type") {
      list = filtered.map((e) => ({ wld_type: e.wld_dropdownValue }));
    } else if (fieldname === "Layer") {
      list = filtered.map((e) => ({ wld_layer: e.wld_dropdownValue }));
    } else if (fieldname === "Welded On Coupon") {
      list = filtered.map((e) => ({ WPQ_Welded_on_coupon: e.wld_dropdownValue }));
    } else {
      list = noSelectFields.includes(fieldname)
        ? filtered.map((e) => ({ name: e.wld_dropdownValue, value: e.wld_dropdownValue }))
        : [{ name: "Select", value: "" }, ...filtered.map((e) => ({ name: e.wld_dropdownValue, value: e.wld_dropdownValue }))];
    }
    arr.length = 0;
    arr.push(...list);
  });
};

export const getDropdownData = async (fieldname) => {
  let list = noSelectFields.includes(fieldname) ? [] : [{ name: "Select", value: "" }];
  let data = await getDropdownRecordsByFieldname({ wld_fieldName: fieldname });
  if (Array.isArray(data)) {
    if (fieldname === "Type") {
      list = data.map((e) => ({ wld_type: e.wld_dropdownValue }));
    } else if (fieldname === "Welded On Coupon") {
      list = data.map((e) => ({ WPQ_Welded_on_coupon: e.wld_dropdownValue }));
    } else if (fieldname === "Layer") {
      list = data.map((e) => ({ wld_layer: e.wld_dropdownValue }))
    } else {
      list.push(...data.map((e) => ({ name: e.wld_dropdownValue, value: e.wld_dropdownValue })));
    }
  }
  return list;
};

//List of all the dropdown fields
export const dropdownFields = [
  { "fieldname": "Process Category" },
  { "fieldname": "Backing" },
  { "fieldname": "Type" },
  { "fieldname": "Flux Type" },
  { "fieldname": "Flux from recrush" },
  { "fieldname": "Alloy Flux" },
  { "fieldname": "Alloy element" },
  { "fieldname": "Addition/Deletion of filler" },
  { "fieldname": "Addition/Deletion of Flux(GTAW)" },
  { "fieldname": "Filler Metal Product Form" },
  { "fieldname": "Layer No." },
  { "fieldname": "Position Of Groove" },
  { "fieldname": "Weld Progression" },
  { "fieldname": "Current Polarity" },
  { "fieldname": "Tungsten Size" },
  { "fieldname": "Tungsten Type" },
  { "fieldname": "Arc Transfer Mode(FCAW/GMAW)" },
  { "fieldname": "Multiple / Single Pass Per Side" },
  { "fieldname": "Type (Post Weld Heat Treatment (QW-407))" },
  { "fieldname": "Wrap In Insulation Material" },
  { "fieldname": "Back Gouging Method" },
  { "fieldname": "Initial/ Interpass Cleaning" },
  { "fieldname": "Peening" },
  { "fieldname": "Supplementary MF Control" },
  { "fieldname": "Surface Preparation" },
  { "fieldname": "Use of Thermal Process" },
  { "fieldname": "Oscillation" },
  { "fieldname": "Closed to out Chamber" },
  { "fieldname": "Weld Layer(s)" },
  { "fieldname": "Addition/Deletion or Changes > 10% in suppl. filler metal" },
  { "fieldname": "Position Of Overlay" },
  { "fieldname": "Division" },
  { "fieldname": "Plant Location" },
  { "fieldname": "Filler Wire With/Without" },
  { "fieldname": "Consumable Insert" },
  { "fieldname": "Filler Metal Product Form (GTAW)" },
  { "fieldname": "Backing Gas" },
  { "fieldname": "Direct/Remote visual control (Machine)" },
  { "fieldname": "Automatic joint tracking (Machine)" },
  { "fieldname": "Single Pass/Multi pass per side" },
  { "fieldname": "Welded On Coupon" },
  { "fieldname": "Joint Type" },
  { "fieldname": "NDT Method" },
  { "fieldname": "Repair Location Marked By" },
  { "fieldname": "Repair Removed By" },
  { "fieldname": "Repair Found" },
  { "fieldname": "Company Name" },
  { "fieldname": "Layer" },
  { "fieldname": "Deviation Category" },
  { "fieldname": "Deviation Severity Level" },
  { "fieldname": "WC in Kgs/Nos" },
  { "fieldname": "Welding Standard" }
]

